<div class="filter-modal">
  <div class="facs-filters-container">
    <div class='inner-container'>
      <div class="header">
        <div class="title">Redistribuir Leads</div>
        <img class='close-btn' src="../../../../assets/svgs/close_btn.svg" alt="close" (click)="handleClose()">
      </div>
      <div>
        <div class='inner-container'>
          <div class='filter__select--margin'>
            <span>Fila</span>
            <app-select-options
              [text]="form.queue ? form.queue : 'Fila'"
              [changeLate]="false"
              [listOptions]="queueOptions"
              (sendChange)="handleSelect($event)">
            </app-select-options>
          </div>
          <div class='filter__select--margin'>
            <span>Empresa</span>
            <app-select-options
              [text]="form.company ? form.company : 'Empresa'"
              [changeLate]="false"
              [listOptions]="companyOptions"
              (sendChange)="handleSelect($event)">
            </app-select-options>
          </div>
          <div class='filter__select--margin'>
            <span>Equipe / Corretor</span>
            <app-select-options
              [text]="form.broker ? form.broker : 'Corretor'"
              [changeLate]="false"
              [listOptions]="brokerOptions"
              (sendChange)="handleSelect($event)">
            </app-select-options>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>